import { httpsCallable } from 'firebase/functions';

import { functions } from '../Firebase';

export const puzzleRejectedNotificationApi = async (puzzleId: string, message?: string) => {
  const _puzzleRejectedNotificationApi = httpsCallable(functions, 'puzzleRejectedNotification');
  return await _puzzleRejectedNotificationApi({ puzzleId: puzzleId, message });
};

export const puzzleApprovedNotificationApi = async (puzzleId: string) => {
  const _puzzleApprovedNotificationApi = httpsCallable(functions, 'puzzleApprovedNotification');
  return await _puzzleApprovedNotificationApi({ puzzleId: puzzleId });
};
